// kept apart from campaign-list-actions, whose content-editor import breaks the mobile bundle
import type { RecipientListId } from 'types/list'
import type { Thunk } from 'types/redux'
import api from '@disco/api/server'
import { CAMPAIGN_DETAILS_UPDATE } from '@disco/constants/ActionTypes'
import {
  getCampaign,
  getCampaigns,
} from '@disco/state-management/selectors/campaigns'
import captureError from '@disco/utils/captureError'

// the backend rebuilds recipients during the list edit, so only the stored count is stale
export const refreshCampaignsUsingList =
  (listId: RecipientListId): Thunk =>
  async (dispatch, getState) => {
    const { loaded, emailCampaigns } = getCampaigns(getState())
    if (!loaded) return
    const campaigns = emailCampaigns.filter(campaign => {
      if (campaign.status !== 'draft' && campaign.status !== 'scheduled')
        return false
      // recipients_filter is untyped server json
      const rules = campaign.recipients_filter?.rules
      if (!Array.isArray(rules)) return false
      return rules.some(rule => {
        if (rule?.ruleType !== 'mailingList') return false
        // older drafts store the list as a {label, value} object
        const value =
          typeof rule.ruleValue === 'object'
            ? rule.ruleValue?.value
            : rule.ruleValue
        return parseInt(value) === listId
      })
    })
    await Promise.all(
      campaigns.map(async ({ id: campaignId }) => {
        try {
          const { recipients_count } = await api.getCampaign(campaignId)
          // updating a campaign deleted while the fetch was out would put an empty one back in the store
          if (!getCampaign(getState(), { campaignId })) return
          dispatch({
            type: CAMPAIGN_DETAILS_UPDATE,
            campaignId,
            updatedFields: { recipients_count },
          })
        } catch (error) {
          captureError(error, {
            description: 'Error in refreshCampaignsUsingList()',
          })
        }
      }),
    )
  }
